import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, CardTitle, Divider, LILAC_200, LILAC_400, StateConfigContext, TRANSPARENT, WHITE, checkIsPlatform, getTestId, isValidObject, tokens } from '@airtel/air-design-system';
import { useCallback, useRef, useState, useEffect, useContext, useMemo } from 'react';
import { FlatList, View } from 'react-native';
import { LinkListItemWidget } from '../link-list-item-widget';
import { StatusCardWidget } from '../status-card-widget';
import { getScrollLinkListWidgetStyles } from './ScrollLinkListWidgetStyles';
import { getRenderListData } from './ScrollLinkListWidgetUtils';
import { CalloutWidget } from '../callout-widget';
import { InputWidget } from '../input-widget';
export var ScrollLinkListWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? true : _props$showDivider,
    _props$commonLinkList = props.commonLinkListProps,
    commonLinkListProps = _props$commonLinkList === void 0 ? {} : _props$commonLinkList,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    id = props.id,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    _props$showExpandCta = props.showExpandCta,
    showExpandCta = _props$showExpandCta === void 0 ? false : _props$showExpandCta,
    _props$showCtaOnConta = props.showCtaOnContainer,
    showCtaOnContainer = _props$showCtaOnConta === void 0 ? false : _props$showCtaOnConta,
    ctaOnContainerTitle = props.ctaOnContainerTitle,
    _onPress = props.onPress,
    onListItemPress = props.onListItemPress,
    onUserAction = props.onUserAction,
    _props$noResults = props.noResults,
    noResults = _props$noResults === void 0 ? {} : _props$noResults,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ScrollLinkListWidget' : _props$testID,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? 'primary' : _props$buttonType,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    cardTitleProps = props.cardTitleProps,
    listFooterStyle = props.listFooterStyle,
    showFooterDivider = props.showFooterDivider,
    footerDividerStyles = props.footerDividerStyles,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? theme == 'white' ? TRANSPARENT : LILAC_200 : _props$backgroundColo,
    flatListStyles = props.flatListStyles,
    ctaContainerProps = props.ctaContainerProps,
    _props$isSelectable = props.isSelectable,
    isSelectable = _props$isSelectable === void 0 ? false : _props$isSelectable,
    _props$selectableType = props.selectableType,
    selectableType = _props$selectableType === void 0 ? 'single' : _props$selectableType,
    _props$selectableData = props.selectableData,
    selectableData = _props$selectableData === void 0 ? {} : _props$selectableData,
    _props$enableStickyFo = props.enableStickyFooter,
    enableStickyFooter = _props$enableStickyFo === void 0 ? false : _props$enableStickyFo,
    _props$enableSearchIn = props.enableSearchInput,
    enableSearchInput = _props$enableSearchIn === void 0 ? false : _props$enableSearchIn,
    _props$searchInputPro = props.searchInputProps,
    searchInputProps = _props$searchInputPro === void 0 ? {} : _props$searchInputPro,
    _props$flatlistProps = props.flatlistProps,
    flatlistProps = _props$flatlistProps === void 0 ? {} : _props$flatlistProps;
  var _ref = expandCtaData || {},
    _ref$expandedCtaTitle = _ref.expandedCtaTitle,
    expandedCtaTitle = _ref$expandedCtaTitle === void 0 ? 'View More' : _ref$expandedCtaTitle,
    _ref$collapseCtaTitle = _ref.collapseCtaTitle,
    collapseCtaTitle = _ref$collapseCtaTitle === void 0 ? 'Show Less' : _ref$collapseCtaTitle,
    _ref$initialItemCount = _ref.initialItemCount,
    initialItemCount = _ref$initialItemCount === void 0 ? 4 : _ref$initialItemCount,
    _ref$expandedIconName = _ref.expandedIconName,
    expandedIconName = _ref$expandedIconName === void 0 ? 'DownChevronButtonIcon' : _ref$expandedIconName,
    _ref$collapseIconName = _ref.collapseIconName,
    collapseIconName = _ref$collapseIconName === void 0 ? 'UpChevronButtonIcon' : _ref$collapseIconName,
    _ref$accessibilityPro = _ref.accessibilityProps,
    accessibilityProps = _ref$accessibilityPro === void 0 ? {} : _ref$accessibilityPro;
  var _useState = useState(false),
    showFullList = _useState[0],
    setShowFullList = _useState[1];
  var scrollLinkListWidgetStyles = getScrollLinkListWidgetStyles();
  var renderedData = getRenderListData(showFullList, showExpandCta, data, initialItemCount);
  var shouldShowViewMoreButton = (data === null || data === void 0 ? void 0 : data.length) > initialItemCount;
  var setOfVisitedIds = useRef(new Set());
  var _useState2 = useState({}),
    selectedState = _useState2[0],
    setSelectedState = _useState2[1];
  var _useState3 = useState(''),
    searchQuery = _useState3[0],
    setSearchQuery = _useState3[1];
  var toggleShowFullList = () => {
    setShowFullList(!showFullList);
  };
  useEffect(() => {
    if (isSelectable && isValidObject(selectableData)) {
      setSelectedState(prevState => {
        var index = selectableData === null || selectableData === void 0 ? void 0 : selectableData.index;
        var value = !(prevState === null || prevState === void 0 ? void 0 : prevState[index]);
        if (selectableType === 'multi') {
          return Object.assign(Object.assign({}, prevState), {
            [index]: value
          });
        } else if (selectableType === 'singleWithRadio') {
          value = (prevState === null || prevState === void 0 ? void 0 : prevState[index]) || value;
          return {
            [index]: value
          };
        } else {
          return {
            [index]: value
          };
        }
      });
    }
  }, [selectableData]);
  var renderListItem = _ref2 => {
    var item = _ref2.item,
      index = _ref2.index;
    var showListDivider = showDivider || (item === null || item === void 0 ? void 0 : item.showDivider);
    return _jsxs(View, Object.assign({}, getTestId(testID), {
      children: [_jsx(LinkListItemWidget, Object.assign({}, item, commonLinkListProps, {
        style: [item === null || item === void 0 ? void 0 : item.style, commonLinkListProps === null || commonLinkListProps === void 0 ? void 0 : commonLinkListProps.style],
        onPress: (item === null || item === void 0 ? void 0 : item.onPress) || onListItemPress,
        onUserAction: onUserAction
      }, isSelectable && {
        [selectableData === null || selectableData === void 0 ? void 0 : selectableData.key]: selectedState === null || selectedState === void 0 ? void 0 : selectedState[index]
      }, {
        showDivider: !isValidObject(item === null || item === void 0 ? void 0 : item.calloutProps) && showListDivider && index !== filteredData.length - 1
      }, getTestId(testID, index.toString()), {
        theme: theme
      })), isValidObject(item === null || item === void 0 ? void 0 : item.calloutProps) && _jsx(View, Object.assign({
        style: {
          marginHorizontal: tokens.spacing.SPACING_16,
          marginBottom: index !== filteredData.length - 1 ? tokens.spacing.SPACING_16 : 0
        }
      }, {
        children: _jsx(CalloutWidget, Object.assign({}, item === null || item === void 0 ? void 0 : item.calloutProps, getTestId(testID + ("_" + index.toString()), 'calloutProps'), {
          onUserAction: onUserAction,
          theme: theme
        }))
      })), showListDivider && isValidObject(item === null || item === void 0 ? void 0 : item.calloutProps) && index !== filteredData.length - 1 && _jsx(Divider, {})]
    }));
  };
  var ListFooterComponent = () => {
    var listFooterComponentStyles = showCtaOnContainer || shouldShowViewMoreButton && showExpandCta;
    return _jsxs(_Fragment, {
      children: [showFooterDivider && _jsx(Divider, Object.assign({
        height: 2,
        color: LILAC_400,
        shadowColor: WHITE,
        style: footerDividerStyles
      }, getTestId(testID, 'divider'), {
        theme: theme
      })), listFooterComponentStyles && _jsxs(View, Object.assign({
        style: [scrollLinkListWidgetStyles.ctaOnContainer, listFooterStyle]
      }, {
        children: [showCtaOnContainer && _jsx(Button, Object.assign({
          buttonType: buttonType,
          size: "md",
          version: "variable-width",
          onPress: () => _onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, _onPress))),
          title: ctaOnContainerTitle,
          showLoader: isLoading
        }, ctaContainerProps, getTestId(testID, 'ctaOnContainerButton'), {
          theme: theme
        })), shouldShowViewMoreButton && showExpandCta && _jsx(Button, Object.assign({
          buttonType: "tertiary",
          size: "md",
          version: "variable-width",
          iconPosition: "right",
          onPress: toggleShowFullList,
          title: showFullList ? collapseCtaTitle : expandedCtaTitle,
          accessibilityLabel: showFullList ? collapseCtaTitle : expandedCtaTitle,
          iconName: showFullList ? collapseIconName : expandedIconName
        }, getTestId(testID, 'viewMoreLessButton'), accessibilityProps, {
          theme: theme
        }))]
      }))]
    });
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    for (var i = 0; i < ((_a = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _a === void 0 ? void 0 : _a.length); i++) {
      var sendImpression = checkIsPlatform('web') && !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has((_c = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _c === void 0 ? void 0 : _c.index));
      if (((_e = (_d = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _d === void 0 ? void 0 : _d[i]) === null || _e === void 0 ? void 0 : _e.index) != null) {
        sendImpression && ((_f = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _f === void 0 ? void 0 : _f.add((_g = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _g === void 0 ? void 0 : _g.index));
        ((_j = (_h = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _h === void 0 ? void 0 : _h[i].item) === null || _j === void 0 ? void 0 : _j.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_l = (_k = info === null || info === void 0 ? void 0 : info.viewableItems) === null || _k === void 0 ? void 0 : _k[i].item) === null || _l === void 0 ? void 0 : _l.onItemImpression), (_m = info === null || info === void 0 ? void 0 : info.viewableItems[i]) === null || _m === void 0 ? void 0 : _m.item));
      }
    }
  }, []);
  var onChangeTextCallback = value => {
    setSearchQuery(value);
  };
  var filteredData = useMemo(() => {
    if (enableSearchInput) {
      return (renderedData === null || renderedData === void 0 ? void 0 : renderedData.filter(item => {
        var _a, _b, _c, _d;
        return (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.heading) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.includes((_d = searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(searchQuery));
      })) || [];
    } else {
      return renderedData;
    }
  }, [searchQuery, renderedData]);
  return _jsxs(View, Object.assign({
    style: [{
      backgroundColor: backgroundColor
    }, style]
  }, {
    children: [isValidObject(cardTitleProps) && _jsx(CardTitle, Object.assign({}, cardTitleProps, {
      style: [scrollLinkListWidgetStyles.cardTitle, cardTitleProps.style],
      theme: theme,
      actionCtaOnPress: () => {
        isValidObject(cardTitleProps === null || cardTitleProps === void 0 ? void 0 : cardTitleProps.actionCtaOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, cardTitleProps === null || cardTitleProps === void 0 ? void 0 : cardTitleProps.actionCtaOnPressMetaData), {
          id,
          cardTitleProps
        }));
      }
    })), enableSearchInput && isValidObject(searchInputProps) && _jsx(InputWidget, Object.assign({}, searchInputProps, {
      onChangeTextCallback: onChangeTextCallback
    })), (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) > 0 && _jsx(FlatList, Object.assign({
      data: filteredData,
      renderItem: renderListItem,
      keyboardShouldPersistTaps: "handled",
      keyExtractor: (_, index) => "list_item_item_" + index,
      ListFooterComponent: !enableStickyFooter ? _jsx(ListFooterComponent, {}) : null,
      onViewableItemsChanged: onViewableItemsChanged,
      style: flatListStyles
    }, flatlistProps, getTestId(testID, 'list'))), enableStickyFooter ? _jsx(ListFooterComponent, {}) : null, (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) === 0 && !!noResults && Object.keys(noResults).length > 0 && _jsx(StatusCardWidget, Object.assign({}, getTestId(testID, 'status'), noResults, {
      onUserAction: onUserAction,
      style: [scrollLinkListWidgetStyles.noResultsContainer, noResults === null || noResults === void 0 ? void 0 : noResults.style]
    }))]
  }));
};
ScrollLinkListWidgetComponent.genericRendererKey = 'AirScrollLinkListWidget';